import * as React from 'react'
import ConditionalLazyLoad from './ConditionalLazyLoad'
import { Img } from './SmartImage.styles'

interface IProps {
  src: string
  placeholderSrc?: string
  srcSet?: string
  height?: number
  width?: number
  critical: boolean
  overflow: boolean
}

export default function SrcSmartImage(props: IProps) {
  const { placeholderSrc, width, height, critical, overflow } = props
  const placeholder = renderPlaceholderMaybe(placeholderSrc, height, width)

  return (
    <ConditionalLazyLoad
      once
      lazyLoad={!critical}
      overflow={overflow}
      height={height}
      placeholder={placeholder}
    >
      <Img {...props} />
    </ConditionalLazyLoad>
  )
}

function renderPlaceholderMaybe(src?: string, height?: number, width?: number) {
  if (src === undefined) return

  return <Img src={src} height={height} width={width} />
}
